<div class="questionnaire-detail">
  <div class="content">
    <h2 class="heading-title">
      {{ questionnaire?.title }}
    </h2>
    @for (question of questionnaire.questions; track question; let i = $index) {
      <div class="question-answer">
        <div class="label-title position-question">項目{{ i + 1 }}</div>
        <div class="label-title question-info">設問文</div>
        <div class="block-element">
          <p class="question-content" appConvertLink>{{ question.text }}</p>
          @if (question.src) {
            <img class="question-image" src="{{ question.src }}" />
          }
          <p class="label-title answer-info">回答</p>
          @for (answer of getListAnswer(questionnaire.answers[i]); track answer) {
            @for (answerOption of getListAnswerOption(answer); track answerOption) {
              @if (answerOption.text) {
                <p class="answer-content preserve-line-break" appConvertLink>{{ answerOption.text }}</p>
              }
              @if (answerOption.src) {
                <img class="answer-image" src="{{ answerOption.src }}" />
              }
            }
            <div class="col-sm-12 col-xs-12 block-attached">
              <div class="row">
                @if (answer.attached) {
                  <div class="image-attached col-md-3 col-sm-4 col-four-1440 col-xs-6" (window:resize)="resize()" #upload_div>
                    <div class="attach attach-image" (click)="onFileClick(answer)">
                      @if (isShowThumbnail(answer.attached_file_name)) {
                        <div class="attach-file">
                          <img [src]="answer.attached" />
                        </div>
                      } @else {
                        <div class="file-format"><i [ngClass]="answer.attached_file_name | fileIconClass"></i></div>
                      }
                      @if (showDownloadIcon(answer)) {
                        <a class="action-file">
                          <i class="fa fa-download"></i>
                        </a>
                      }
                    </div>
                    <a class="file-name" (click)="onFileClick(answer)">{{ answer.attached_file_name }}</a>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!!questionnaire.category_name) {
      <div class="category-text">
        {{ questionnaire.category_name }}
      </div>
    }
  </div>
  @if (questionnaire.commented_user) {
    <div class="assessment">
      <div class="row">
        <div class="col-xs-2">
          <div class="logo">
            <img [src]="questionnaire.commented_user?.avatar" alt="Avatar" class="img-responsive" />
          </div>
        </div>
        <div class="col-xs-10">
          <div class="user-info">
            <div class="info">
              <p class="date">{{ questionnaire.created_at | date: 'yyyy/MM/dd HH:mm' }}</p>
              <p class="name">{{ questionnaire.commented_user.name }}{{ isTeacher() ? '先生' : '' }}</p>
            </div>
          </div>
          <div class="text-content">
            <app-read-more [content]="questionnaire.commented_text"></app-read-more>
          </div>
        </div>
      </div>
    </div>
  }

  <app-questionnaire-file-preview></app-questionnaire-file-preview>
</div>
